import { CALL_API } from "../context/constValues";
import { getAuthToken } from "../context/auth-context";

// ✅ Obtener todos los medicamentos base
export async function getAllMedicamentos2() {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/getallmedicamentos2`, {
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al obtener medicamentos");
  }

  return data.result;
}

// ✅ Insertar medicamento base
export async function insertMedicamento2(objeto) {
  const {
    nombre,
    principioActivo,
    formaFarmaceutica,
    concentracion,
    presentacion,
    unidadMedida,
    laboratorio,
    observacion,
  } = objeto;

  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/insertmedicamento2`, {
    method: "POST",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      nombre,
      principioActivo,
      formaFarmaceutica,
      concentracion,
      presentacion,
      unidadMedida,
      laboratorio,
      observacion,
    }),
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al insertar medicamento");
  }

  return data.isSaved;
}

// ✅ Actualizar medicamento base
export async function updateMedicamento2(objeto) {
  const {
    idMedicamento,
    nombre,
    principioActivo,
    formaFarmaceutica,
    concentracion,
    presentacion,
    unidadMedida,
    laboratorio,
    observacion,
  } = objeto;

  const token = getAuthToken();
  const response = await fetch(
    `${CALL_API}/updatemedicamento2/${idMedicamento}`,
    {
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        idMedicamento,
        nombre,
        principioActivo,
        formaFarmaceutica,
        concentracion,
        presentacion,
        unidadMedida,
        laboratorio,
        observacion,
      }),
    }
  );

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al actualizar medicamento");
  }

  return data.isUpdated;
}

// ✅ Borrado lógico
export async function deleteMedicamento2(id) {
  const token = getAuthToken();
  const response = await fetch(`${CALL_API}/deletemedicamento2/${id}`, {
    method: "DELETE",
    headers: { Authorization: "Bearer " + token },
  });

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || "Error al eliminar medicamento");
  }

  return data.isDeleted;
}
